/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { HolidayCheckRequestViewModel } from "../types/HolidayCheckRequestViewModel.ts";

export const holidayCheckRequestViewModelSchema = z.object({
  dates: z.array(z.string().datetime()).nullish(),
  classStudentIds: z.array(z.number().int()).nullish(),
}) as unknown as ToZod<HolidayCheckRequestViewModel>;
